import { token } from 'constant/localStorage'

const API_URL = process.env.REACT_APP_API_URL

export const listDataOnboard = async () => {
  try {
    const response = await fetch(`${API_URL}/companies`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token()}`
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === 401 && errorData.code_type === "unAuthorized") {
        window.location.href = "/login";
      } else {
        throw errorData.code_message;
      }
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export const createOnBoard = async (item) => {
  try {
    const response = await fetch(`${API_URL}/companies`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token()}`
      },
      body: JSON.stringify(item),
    });

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === 401 && errorData.code_type === "unAuthorized") {
        window.location.href = "/login";
      } else {
        throw errorData.code_message;
      }
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export const updateStatus = async (item) => {
  try {
    const response = await fetch(`${API_URL}/companies/${item.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token()}`
      },
      body: JSON.stringify(item),
    });

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === 401 && errorData.code_type === "unAuthorized") {
        window.location.href = "/login";
      } else {
        throw errorData.code_message;
      }
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}